import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

import InputSelector from './InputSelector';
import { noop } from 'common';

const useStyles = makeStyles(theme => ({
  root: {},
  paper: {
    padding: '12px 16px',
    backgroundColor: '#fff',
    boxShadow: theme.shadows[1],
    width: 211,
  },
  option: {
    padding: '12px 16px',
    fontSize: 12,
    display: 'flex',
    gap: 15,
    alignItems: 'center',
    backgroundColor: '#fff',
    cursor: 'pointer',
    transition: theme.transitions.create(['background-color', 'color']),
    '&:hover': {
      // 60% "lighter" than selected color
      backgroundColor: '#EBF7FF',
    },
  },
  selected: {
    backgroundColor: '#525E6A',
    color: '#fff',
    '&:hover': {
      // 10% "lighter"
      backgroundColor: '#6C7884',
    },
  },
}));

const InputSelect = props => {
  const classes = useStyles();
  const { options = [], value, onChange = noop, ...rest } = props;
  return (
    <div className={classes.root}>
      <InputSelector {...rest}>
        {setOpen => {
          return (
            <div className={classes.paper}>
              {options.map(option => {
                return (
                  <div
                    key={option.key}
                    className={clsx(classes.option, value === option.key && classes.selected)}
                    onClick={() => {
                      onChange(option.key);
                      setOpen(false);
                    }}
                    data-test-id={`input-select-option-${option.key}`}
                  >
                    {option.label}
                  </div>
                );
              })}
            </div>
          );
        }}
      </InputSelector>
    </div>
  );
};

export default InputSelect;
